import React from "react";
import products from "../data";

export default function ProductList({ addToCart }) {
  return (
    <div className="container mt-4">
      <div className="row">
        {products.map((item) => (
          <div className="col-md-4" key={item.id}>
            <div className="card mb-4">
              <img src={item.img} className="card-img-top" alt={item.name} height={400} width={500} />
              <div className="card-body text-center">
                <h5>{item.name}</h5>
                <p>₹{item.price}</p>
                <button
                  className="btn btn-primary"
                  onClick={() => addToCart(item)}
                >
                  Add to Cart
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}